<script>
  import TypeIcon from './type-icon.svelte'
  import { CornerDownLeft } from 'lucide-svelte'
  import searchState from '@state/global-search-state.svelte.js'
  import { highlightQuery } from './highlight.js'

  let { item, index, list } = $props()

  let highlighted = $derived(list.index === index)
  let name = $derived(item.label || item.name || "Document")

  let highlightedName = $derived.by(() => {
    return highlightQuery(name, searchState.highlight ? list.query : "")
  })

  // let buttonClass = $derived(cn("w-full relative flex items-center gap-2 px-[0.35rem] pt-[0.65rem] pb-[0.55rem] first-of-type:pt-[0.8rem] last-of-type:pb-[0.8rem]", highlighted ? "bg-blue-100/30" : ""))
  let buttonClass = $derived(highlighted ? "item highlighted" : "item hover:bg-stone-100/50")

</script>

<button type="button" bind:this={list.refs[index]} class={buttonClass} title={name} onpointerdown={() => list.selectItem(index)}>

  <!-- Type icon wrapped in a stone background -->
   <div class="icon-bg" class:highlighted>
    <TypeIcon type={item.prefix} size={18} class="item-icon" />
  </div>
  
  <!-- The button text -->
  <div class="flex flex-col items-start leading-tight overflow-hidden">
    <span class="text-[15px] font-medium text-gray-700 truncate">{@html highlightedName}</span>
    <span class="text-smaller text-gray-400">{item.prefix}</span>
  </div>

  <!-- If item is highlighted, show the "Enter" arrow -->
  {#if highlighted}
    <CornerDownLeft size={16} class="text-gray-300 absolute right-2" />
  {/if}
</button>

<style>

  .item {
    width: 100%;
    display: flex;
    align-items: stretch;
    gap: 0.75rem;
    padding: 0.6rem 0.55rem;
    position: relative;
    border-radius: 0.25rem;
    &:first-of-type { padding-top: 0.8rem; }
    &:last-of-type { padding-bottom: 0.8rem; }
    &.highlighted {
      background: linear-gradient(to right, #F2F5FA, #F6F7F9);
    }
    &:hover {
      /* Half as dark as the highlighted background */
      background: rgba(242, 245, 250, 0.5);
    }
  }
  
  .icon-bg {
    /* flex items-center justify-center w-[2rem] min-w-[2rem] h-[2rem] p-1 bg-stone-100/60 flex-shrink-0 */
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    min-width: 2rem;
    height: 2rem;
    padding: 0.25rem;
    background: linear-gradient(45deg, #F7F9FE, #F9FBFD);
    color: #CCCDDB;
    border-radius: 0.25rem;
    &.highlighted {
      background: #FFF;
      color: #CCCDDB;
    }
  }

  .item-icon {
    color: #CCCDDB;
  }

  :global(.query-highlight) {
    background: rgba(254, 240, 138, 0.65);
    color: inherit;
    border-radius: 0.125rem;
    padding: 0 0.0625rem;
  }
</style>
